/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvaluationChartLine } from './EvaluationChartLine';
import {
    EvaluationChartLineFromJSON,
    EvaluationChartLineFromJSONTyped,
    EvaluationChartLineToJSON,
} from './EvaluationChartLine';

/**
 * 
 * @export
 * @interface EvaluationChartResponse
 */
export interface EvaluationChartResponse {
    /**
     * 
     * @type {Array<EvaluationChartLine>}
     * @memberof EvaluationChartResponse
     */
    lines: Array<EvaluationChartLine>;
}

/**
 * Check if a given object implements the EvaluationChartResponse interface.
 */
export function instanceOfEvaluationChartResponse(value: object): value is EvaluationChartResponse {
    if (!('lines' in value) || value['lines'] === undefined) return false;
    return true;
}

export function EvaluationChartResponseFromJSON(json: any): EvaluationChartResponse {
    return EvaluationChartResponseFromJSONTyped(json, false);
}

export function EvaluationChartResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationChartResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'lines': ((json['lines'] as Array<any>).map(EvaluationChartLineFromJSON)),
    };
}

export function EvaluationChartResponseToJSON(value?: EvaluationChartResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lines': ((value['lines'] as Array<any>).map(EvaluationChartLineToJSON)),
    };
}

